/**
 * Constants for the trading dashboard.
 */

// Crypto pairs - All 30 trading pairs (matches backend)
export const SOLID100 = [
  // Major pairs (high liquidity)
  'BTC-USD','ETH-USD','SOL-USD','AVAX-USD','LINK-USD',
  'XRP-USD',
  // High Volatility / Memes (High Beta)
  'PEPE-USD', 'SHIB-USD', 'BONK-USD', 'WIF-USD',
  // AI & Trending Narratives
  'FET-USD', 'JTO-USD', 'PYTH-USD', 'ENS-USD', 'LDO-USD', 'STX-USD',
  // Mid-caps & Layer 1s
  'NEAR-USD','APT-USD','OP-USD',
  'ARB-USD','MKR-USD','INJ-USD','TIA-USD','SEI-USD',
  'SUI-USD','RENDER-USD','GRT-USD','IMX-USD','MANA-USD'
];

// Cryptocurrency names mapping
export const companyNames = {
  'BTC-USD': 'Bitcoin',
  'ETH-USD': 'Ethereum', 
  'SOL-USD': 'Solana',
  'AVAX-USD': 'Avalanche',
  'LINK-USD': 'Chainlink',
  'XRP-USD': 'XRP',
  'PEPE-USD': 'Pepe',
  'SHIB-USD': 'Shiba Inu',
  'BONK-USD': 'Bonk',
  'WIF-USD': 'dogwifhat',
  'FET-USD': 'Artificial Superintelligence',
  'JTO-USD': 'Jito',
  'PYTH-USD': 'Pyth Network',
  'ENS-USD': 'Ethereum Name Service',
  'LDO-USD': 'Lido DAO',
  'STX-USD': 'Stacks',
  'NEAR-USD': 'NEAR Protocol',
  'APT-USD': 'Aptos',
  'OP-USD': 'Optimism',
  'ARB-USD': 'Arbitrum',
  'MKR-USD': 'Maker',
  'INJ-USD': 'Injective',
  'TIA-USD': 'Celestia',
  'SEI-USD': 'Sei',
  'SUI-USD': 'Sui',
  'RENDER-USD': 'Render',
  'GRT-USD': 'The Graph',
  'IMX-USD': 'Immutable',
  'MANA-USD': 'Decentraland'
};
